import React from 'react';
import { useSelector } from 'react-redux';

import initContainerData from 'bdata-react-component/lib/store/initContainerData';

import standingsDatasource from '../../../core/datasources/standings';

import teamSummaryMatchupDataRequestAction from '../../TeamSummaryMatchup/store/actions/teamSummaryMatchupDataRequestAction';

import previewInfoReducer from '../store/reducers/previewInfo';
import { getPreviewInfoState } from '../store/selectors/previewInfoSelector';

import PreviewInfo from '../PreviewInfo';

initContainerData.register({
    datasources: {
        standings: standingsDatasource
    },
    reducers: {
        previewInfo: previewInfoReducer
    }
});

const fetchData = () => teamSummaryMatchupDataRequestAction();

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const PreviewInfoDataContainer = () => {
    const previewInfoState = useSelector(getPreviewInfoState);

    return <PreviewInfo { ...previewInfoState } />;
};

export default PreviewInfoDataContainer;

export { routes };
